import { createSlice } from '@reduxjs/toolkit';
import { createAppAsyncThunk } from '../createAppAsyncThunk';
import { API_POST } from '../../services';
import type { RootState } from '../store';
import { env } from '../../env';
import { ENDPOINTS } from '../../constants/endPoints';
import { HGReportResponse } from '../../models/HGReportModel';
import { RADRequest } from '../../models/common/RADRequest';

interface HGReportState {
  data: HGReportResponse | null;
  isLoading: boolean;
}

const initialState: HGReportState = {
  data: null,
  isLoading: false,
};

// Async thunk to fetch Higher Ground report data
export const fetchHGReportData = createAppAsyncThunk(
  'hgReport/fetchHGReportData',
  async (payload: RADRequest) => {
    const requestBody = {
      StoreNumber: payload.storeNumber,
      IsMultiStoreMode: payload.isMultiStoreMode ?? false,
    };

    const response = await API_POST(
      `${env.RAD_APP_API_URL}${ENDPOINTS.GET_HG_REPORT_DATA}`,
      requestBody,
    );
    return response as HGReportResponse;
  },
);

// Higher Ground Report slice
const hgReportSlice = createSlice({
  name: 'hgReport',
  initialState,
  reducers: {
    resetHGReportData: state => {
      state.data = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchHGReportData.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchHGReportData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchHGReportData.rejected, state => {
        state.data = null;
        state.isLoading = false;
      });
  },
});

export const { resetHGReportData } = hgReportSlice.actions;

// Selectors
export const selectHGReportData = (state: RootState) => state.hgReport.data;
export const selectHGReportLoading = (state: RootState) => state.hgReport.isLoading;

export default hgReportSlice.reducer;
